import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import React, {useEffect, useState} from "react";
import '../public/styles/style.css';
import {APIs} from "../constants/api.constants";
import {gridOption, frameworkComponents, dateFilterParams} from '../constants/ag-grid.constants';
import {ApiService} from "../services/ApiService";
import AddNewSubscription from "../custom-components/subscription-record-popups/add-new-subscription";
import {notification, Pagination, Select, Spin} from "antd";
import moment from "moment";
import DeleteSubscriptionRecord from '../custom-components/subscription-record-popups/delete-subscription';
import Search from 'antd/lib/input/Search';
import EditSubscriptionRecord from '../custom-components/subscription-record-popups/edit-subscription';
import SortingTypeOption from '../custom-components/filter-and-sorting-popovers/sorting-type-option';
import { subscriptionRecordSortingConstant } from '../constants/sorting.constants';

export default function SubscriptionRecord() {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [visible, setVisibility] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [accessGroups, setAccessGroups] = useState([]);
  const [selectedUser, setUser] = useState();
  const [selectedAccessGroup, setAccessGroup] = useState();
  const [loadingRows, setLoadingRows] = useState(false);
  const [selectedDate, setNewDate] = useState(null);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [checkBox1, setCheckBox1] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState({});
  const [usersLoading, setUsersLoading] = useState(false)
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalSubscription, setTotalSubscription] = useState(null);
  const [filterValue, setFilterValue] = useState("");
  const [sort, setSort] = useState("idAscending")
  const [editVisible, setEditVisible] = useState(false);
  const [startDate, setStartDate] = useState(null)

  const columnDefs = [
    {
      headerName: 'ID',
      field: 'id',
      minWidth: 350,
      editable: false,
    },
    {
      headerName: 'Date/Time',
      valueGetter: (param) => param.data?.starting_date
          ? new Date(param.data?.starting_date)?.toLocaleString("en-GB")
          : '-',
      minWidth: 200,
      filter: 'agDateColumnFilter',
      filterParams: dateFilterParams,
      editable: false,
    },
    {
      headerName: 'User ID',
      field: "id",
      minWidth: 80,
      valueGetter: (param) => param.data?.user?.id || '-',
      editable: false,
    },
    {
      field: "email",
      minWidth: 300,
      valueGetter: (param) => param.data?.user?.email || '-',
      editable: false,
    },
    {
      field: "accessGroup",
      minWidth: 200,
      valueGetter: (param) => param.data?.access_group?.name || '-',
      editable: false,
    },
    {
      field: "Activate",
      cellRenderer: "customSwitch",
      editable: false,
      cellRendererParams: {
        param: 'activate',
        clicked: function (field) {
          changeActiveStatus(field);
        }
      },
      minWidth: 120,
    },
    {
      field: "Edit",
      editable: false,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: "Edit",
        buttonClass: "primary",
        clicked: function (field) {
          setStartDate(field.starting_date)
          setSubscriptionData(field)
          toggleEditPopup()
        }
      },
      minWidth: 100,
    },
    {
      headerName: "Soft Delete",
      field: "deletedAt",
      cellRenderer: "customSwitch",
      editable: false,
      sort: 'asc',
      sortIndex: 0,
      cellRendererParams: {
        param: 'deletedAt',
        clicked: function (field) {
          field.deletedAt
              ? recoverSubscription(field)
              : deleteSubscription(field);
        }
      },
      minWidth: 120,
    },
    {
      field: "Deleted",
      editable: false,
      cellRenderer: "btnCellRenderer",
      sortIndex: 0,
      cellRendererParams: {
        buttonText: "Delete",
        buttonClass: "primary",
        clicked: function (field) {
          setSubscriptionData(field)
          setDeleteId(field.id)
          toggleDeletePopup()
        },
      },
      minWidth: 100,
    },
  ];

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  useEffect(() => {
    getRecords().then(() => {
    });
    getUsers().then(() => {
    });
    getAccessGroups()
  }, []);

  async function getRecords(
      page = 1,
      limit = 100,
      sorting = "idAscending",
      filterValue
  ) {
    setLoadingRows(true);
    const param = {
      limit: limit,
      page: page,
      filterValue: filterValue,
      sorting: sorting,
    };
    ApiService.getRequest(APIs.subscriptions + "/pagination", param).then(
        (res) => {
          setTotalSubscription(res.data.meta.totalCount);
          setData(res.data.data);
          setLoadingRows(false);
        },
        (error) => notification["error"]({message: error.message})
    );
  }

  function changeActiveStatus(newData) {
    if (!newData?.user?.email) {
      return;
    }
    const postData = {
      activate: !data.filter(item => item.id === newData.id)[0].activate,
    }
    ApiService.updateRequest(APIs.subscriptions + '/' + newData.id, postData).then(
        (res) => {
          const index = data.findIndex(subs => subs.id === newData.id);
          data[index] = res.data;
          setData(data);
        },
        (error) => notification['error']({message: error.message})
    );
  }

  function deleteSubscription(event) {
    ApiService.deleteRequest(APIs.subscriptions + '/' + event.id).then(
        () => getRecords(page, limit, sort, filterValue),
        (error) => {
          notification['error']({message: error.message});
        }
    );
  }

  function recoverSubscription(event) {
    ApiService.updateRequest(APIs.subscriptions + '/recover/' + event.id).then(
        () => getRecords(page, limit, sort, filterValue),
        (error) => {
          notification['error']({message: error.message});
        }
    );
  }

  async function getUsers() {
    setUsersLoading(true);
    ApiService.getRequest(APIs.users + "/compact-users/all").then(
        (res) => {
          setUsers(res.data);
          setUsersLoading(false);
        },
        (error) => {
          notification["error"]({message: error.message});
          setUsersLoading(false);
        }
    );
  }

  function getAccessGroups() {
    ApiService.getRequest(APIs.accessGroup).then(
        (res) => setAccessGroups(res.data),
        (error) => notification['error']({message: error.message})
    );
  }

  function handleCancel() {
    resetValues();
    setVisibility(false);
  }

  function showModal() {
    setVisibility(true);
  }

  function resetValues() {
    setUser(null);
    setAccessGroup(null);
    setNewDate(null);
  }

  function createNewSubscription() {
    if (!selectedUser || !selectedAccessGroup) {
      notification['error']({message: 'Please Select Values'});
      return;
    }
    setLoading(true);
    const data = {
      id: selectedUser,
      sku: selectedAccessGroup,
      subscriptionStartDate: !selectedDate ? new Date() : moment(selectedDate).toDate(),
      activate: true,
    }
    ApiService.postRequest(APIs.subscriptions, data).then(
        (res) => {
          setLoading(false);
          handleCancel();
          getRecords(page, limit, sort, filterValue).then(() => {
          });
        },
        (err) => {
          setLoading(false);
          notification['error']({message: 'Subscription Already Exists'})
        }
    );
  }

  function editSubscription() {
    const data = {
      subscriptionStartDate: moment(startDate).toDate(),
    };
    setLoading(true);
    setLoadingRows(true);
    ApiService.updateRequest(
        APIs.subscriptions + "/startdate/" + subscriptionData.id,
        data
    ).then(
        () => {
          setLoading(false);
          toggleEditPopup();
          getRecords(page, limit, sort, filterValue);
        },
        (error) => {
          notification["error"]({message: error.message});
          setLoading(false);
        }
    );
  }

  function resetDeleteInput() {
    setSubscriptionData({})
    setDeleteId(null)
    setCheckBox1(false)
    setCheckBox2(false)
  }

  function toggleDeletePopup() {
    deleteVisible && resetDeleteInput();
    setDeleteVisible(!deleteVisible)
  }

  function resetEditInput() {
    setSubscriptionData({});
    setStartDate(null);
  }

  function toggleEditPopup() {
    editVisible && resetEditInput();
    setEditVisible(!editVisible);
  }

  function hardDelete() {
    if (checkBox1 !== true || checkBox2 !== true) {
      return notification["error"]({
        message: "please check all the checkbox to confirm deletion",
      });
    }
    setLoading(true);
    setLoadingRows(true);
    ApiService.deleteRequest(APIs.subscriptions + "/hard-delete/" + deleteId).then(
        () => {
          setLoading(false);
          toggleDeletePopup();
          getRecords(page, limit, sort, filterValue);
        }
    ),
        (error) => {
          notification["error"]({message: error.message});
          setLoading(false);
          toggleDeletePopup();
          setLoadingRows(false);
        };
  }

  const addNewSubscriptionsProps = {
    visible, setVisibility, loading, handleCancel, users, accessGroups, selectedDate, setNewDate,
    showModal, selectedUser, setUser, selectedAccessGroup, setAccessGroup, usersLoading, createNewSubscription
  }

  const deleteSubscriptionRecordProps = {
    deleteVisible, toggleDeletePopup, checkBox1, setCheckBox1, setCheckBox2, checkBox2,
    loading, subscriptionData, hardDelete
  }

  const editSubscriptionRecordProps = {
    editVisible,
    toggleEditPopup,
    loading,
    subscriptionData,
    setStartDate,
    startDate,
    editSubscription
  }

  return (
    <>
      <div className={"d-flex w-100percent row no-gutters"}>
        <div className="col-md-5 pr-1 pb-3">
          <Search
            placeholder="input search text"
            allowClear
            onSearch={(value) => {
              setFilterValue(value);
              getRecords(page, limit, sort, value);
            }}
            prefix
            enterButton
          ></Search>
        </div>
        <div className="col-md-4 pr-1 pb-3">
        <SortingTypeOption
            types={subscriptionRecordSortingConstant}
            valueType={sort}
            changeFunction={(value) => {
              setSort(value);
              getRecords(page, limit, value, filterValue);
            }}
          />
        </div>
        <div className="col-md-3 pb-3 text-right">
          <AddNewSubscription props={addNewSubscriptionsProps} />
        </div>
      </div>

      <DeleteSubscriptionRecord props={deleteSubscriptionRecordProps} />
      <EditSubscriptionRecord props={editSubscriptionRecordProps} />

      <Spin tip="Loading...." size="small" spinning={loadingRows}>
        <div className="example-wrapper h-minus-180">
          <div className="ag-theme-alpine w-100percent h-100percent">
            <AgGridReact
              rowData={data}
              columnDefs={columnDefs}
              defaultColDef={gridOption}
              animateRows={true}
              enableCellTextSelection={true}
              frameworkComponents={frameworkComponents}
              getRowNodeId={function (data) {
                return data.id;
              }}
              onGridReady={onGridReady}
            ></AgGridReact>
          </div>
          <div className="d-flex w-100percent justify-content-end pt-2">
            <Pagination
              onChange={(page, limit) => {
                setPage(page);
                setLimit(limit);
                getRecords(page, limit, sort, filterValue);
              }}
              showQuickJumper
              defaultCurrent={1}
              total={totalSubscription}
              pageSize={limit}
              pageSizeOptions={[50, 100, 500, 1000]}
            />
          </div>
        </div>
      </Spin>
    </>
  );
}
